import React from 'react';
import { textPropTypes } from './TextPropTypes';
import * as styles from './Text.module.scss';
const Text = ({
  html
}) => {
  if (!html) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root,
    dangerouslySetInnerHTML: {
      __html: html
    }
  });
};
export default Text;